import { render } from "./videoEdit.vue?vue&type=template&id=2a2e73c7&scoped=true"
import script from "./videoEdit.vue?vue&type=script&lang=js"
export * from "./videoEdit.vue?vue&type=script&lang=js"

import "./videoEdit.vue?vue&type=style&index=0&id=2a2e73c7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2e73c7"],['__file',"src/views/contentCenter/components/videoEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a2e73c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a2e73c7', __exports__)) {
    console.log('reload')
    api.reload('2a2e73c7', __exports__)
  }
  
  module.hot.accept("./videoEdit.vue?vue&type=template&id=2a2e73c7&scoped=true", () => {
    console.log('re-render')
    api.rerender('2a2e73c7', render)
  })

}


export default __exports__